export default {
  subscribe: {
    pageTitle: 'Subscribe for newsletter'
  }
}
